/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../index";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const aiUsage = /* GraphQL */ `query AiUsage($service: String!, $month: String!) {
  aiUsage(service: $service, month: $month) {
    aiServiceName
    month
    usageCount
    __typename
  }
}
` as GeneratedQuery<APITypes.AiUsageQueryVariables, APITypes.AiUsageQuery>;
export const allTenantFeatureSetting = /* GraphQL */ `query AllTenantFeatureSetting {
  allTenantFeatureSetting {
    id
    name
    state
    enablingMessage
    enabledMessage
    disablingMessage
    disabledMessage
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllTenantFeatureSettingQueryVariables,
  APITypes.AllTenantFeatureSettingQuery
>;
export const allWebUIFeatureSetting = /* GraphQL */ `query AllWebUIFeatureSetting {
  allWebUIFeatureSetting {
    id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AllWebUIFeatureSettingQueryVariables,
  APITypes.AllWebUIFeatureSettingQuery
>;
export const deviceDisplayNames = /* GraphQL */ `query getDeviceDisplayNames {
  getDeviceDisplayNames {
    serialIdAndDisplayNameMappings {
      serialId
      displayName
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDeviceDisplayNamesQueryVariables,
  APITypes.GetDeviceDisplayNamesQuery
>;
export const isKintoneTenantSetting = /* GraphQL */ `query IsKintoneTenantSetting {
  isKintoneTenantSetting {
    isSetting
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsKintoneTenantSettingQueryVariables,
  APITypes.IsKintoneTenantSettingQuery
>;
export const kintoneSetting = /* GraphQL */ `query KintoneSetting {
  kintoneSetting {
    endpointUrl
    clientId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KintoneSettingQueryVariables,
  APITypes.KintoneSettingQuery
>;
export const linkServiceTokenExpiredDate = /* GraphQL */ `query LinkServiceTokenExpiredDate($service: String!) {
  linkServiceTokenExpiredDate(service: $service) {
    accessTokenExpiredDate
    refreshTokenExpiredDate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LinkServiceTokenExpiredDateQueryVariables,
  APITypes.LinkServiceTokenExpiredDateQuery
>;
export const tenantDevices = /* GraphQL */ `query TenantDevices {
  tenantDevices {
    deviceId
    serialId
    tenantId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TenantDevicesQueryVariables,
  APITypes.TenantDevicesQuery
>;
